import React, { useEffect, useMemo } from 'react'

import { DatePicker, Select, Space } from 'antd'
import {
  $financeManagers,
  financeManagerMounted,
} from '../../../../billing/withdrawals/list/model'
import { useUnit } from 'effector-react'
import dayjs from 'dayjs'
import { RangePickerProps } from 'antd/es/date-picker'

export type FiltersValue = {
  userIds?: string[]
  datePeriod?: RangePickerProps['value']
}

type Props = {
  value: FiltersValue
  onChange: (payload: FiltersValue) => void
  hasFullAccess: boolean
  classname?: string
}

const { RangePicker } = DatePicker

export const CardVerificationFilters: React.FC<Props> = ({
  value,
  onChange,
  hasFullAccess,
  classname,
}) => {
  const financeManagers = useUnit($financeManagers)
  const financeManagersOptions = useMemo(
    () =>
      financeManagers.map((item) => ({
        label: item.username,
        value: item.id,
      })),
    [financeManagers],
  )

  const disabledDate: RangePickerProps['disabledDate'] = (current) => {
    if (!current) return false

    const [start, end] = value.datePeriod ?? []

    // ограничение выбора будущих дат от текущего дня
    if (current > dayjs().endOf('day')) return true

    // если одна дата уже выбрана — ограничиваем месяц
    if (start && !end) {
      const startOfMonth = start.startOf('month')
      const endOfMonth = start.endOf('month')

      return current < startOfMonth || current > endOfMonth
    }

    return false
  }

  useEffect(() => {
    if (hasFullAccess) {
      financeManagerMounted()
    }
  }, [hasFullAccess])

  return (
    <Space className={classname}>
      <RangePicker
        disabled={[false, !value.datePeriod?.[0]]}
        value={value.datePeriod}
        disabledDate={disabledDate}
        onCalendarChange={(dates) => onChange({ ...value, datePeriod: dates })}
      />
      {hasFullAccess && (
        <Select
          allowClear
          placeholder="Select an user id"
          mode="multiple"
          options={financeManagersOptions}
          value={value.userIds}
          onChange={(ids) =>
            onChange({
              ...value,
              userIds: ids?.length ? ids : undefined,
            })
          }
          style={{ width: 400 }}
        />
      )}
    </Space>
  )
}
